<template>
<div >
  <section id="hero_info">
    <article>
      <div class="main-wraper">
        <img src="/static/renew_img/hero_info.png">
      </div>
      <p class="caption">よくある質問</p>
    </article>
  </section>
  <section class="info-cream">
    <div class="content-wrapper">
      <article class="info">
        <h2 id="info00"<span>目次</span></h2>		
        <ul class="disc">
          <li>yagishについて<br>
            <a href="#info01">└ サービスの利用に料金はかかりますか？</a><br>
            <a href="#info02">└ 書類はどんな出力形式に対応していますか？</a><br>
            <a href="#info03">└ 作成できる履歴書のサイズを教えてください。</a><br>
            <a href="#info04">└ 通信環境が悪くても（またはオフラインでも）履歴書の作成は可能ですか？</a><br>
            
          </li>
          <li>ログイン<br>
            <a href="#info05">└ ログインをしなくても利用できますか？</a><br>
            <a href="#info06">└ ログインはどのように行いますか？</a><br>
            <a href="#info07">└ ログインができません。</a>
          </li>
          <li>入力データと引き継ぎ<br>
            <a href="#info08">└ 携帯を変えました、データを引き継げますか？</a><br>
            <a href="#info09">└ 応募先別に入力内容を保存しておくことはできますか？</a><br>
            <a href="#info10">└ ログインをしていないのに、以前入力した内容が残っていました。</a><br>
            <a href="#info11">└ 入力したデータが消えてしまいました。</a>
          </li>
          <li>コンビニ印刷とダウンロード<br>
            <a href="#info12">└ ダウンロードできません。</a><br>
            <a href="#info13">└ 再ダウンロードの方法が分かりません。</a><br>
            <a href="#info14">└ カラーと白黒印刷の違いはなんですか？</a><br>
            <a href="#info15">└ コンビニで印刷できません。</a><br>
            <a href="#info21">└ 学歴・職歴内の線の太さが違います。</a>
          </li>
          <li>運営会社について<br>
            <a href="#info16">└ 入力した個人情報やデータはどんな風に扱われますか？</a><br>
            <a href="#info17">└ 運営会社はどんな会社ですか？</a>
          </li>
          <li>その他<br>
            <a href="#info18">└ メールが届きません。</a><br>
            <a href="#info19">└ 質問や要望がある場合、どこに問い合わせれば良いですか？</a><br>
            <a href="#info20">└ 退会したい場合はどうすれば良いですか？</a>
          </li>
          
        </ul>
      </article>
    </div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2><span>yagishについて</span></h2>
			<ul class="step">
				<li>
					<p class="step-num" id="info01"><span>Q</span>サービスの利用に料金はかかりますか？</p>
					<p class="plaintext">無料でご利用いただけますが、コンビニ印刷につきましては、有料となります。</p>
				</li>
				<li>
					<p class="step-num" id="info02"><span>Q</span>書類はどんな出力形式に対応していますか？</p>
					<p class="plaintext">PDFでの出力に対応しています。</p>
				</li>
				<li>
					<p class="step-num" id="info03"><span>Q</span>作成できる履歴書のサイズを教えてください。</p>
					<p class="plaintext">履歴書のサイズはA4、A3、B4となります。<br>
						職歴の長さや項目数により、行数やレイアウト、枚数が変わります。<br>
						※ 履歴書の種類や内容に関するご要望・ご意見がありましたら、<a href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform" target="_blank">リクエストフォーム</a>でお伝えいただければ幸いです（今後のアップデートの参考にさせていただきます）</p>
				</li>
				<li>
					<p class="step-num" id="info04"><span>Q</span>通信環境が悪くても（またはオフラインでも）履歴書の作成は可能ですか？</p>
					<p class="plaintext">yagish（ヤギッシュ）はPWA（Progressive Web Apps）に対応しており、一度サイトを読み込めばオフラインでの利用が可能です。地下鉄や通信制限下の環境でも快適に入力ができます。<br>
					<span class="red">※ 履歴書のPDF出力はサーバーとの通信が必要なため、オンライン環境でお試しください。</span></p>
				</li>
			</ul>	
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2><span>ログイン</span></h2>
			<ul class="step">
				<li>
					<p class="step-num" id="info05"><span>Q</span>ログインをしなくても利用できますか？</p>
					<p class="plaintext">履歴書の作成は登録不要でご利用いただけます。<br>
						PDF出力、バックアップ、コンビニ印刷など、より多くの機能を利用する場合はログインをおすすめします。</p>
				</li>
				<li>
					<p class="step-num" id="info06"><span>Q</span>ログインはどのように行いますか？</p>
					<img src="/static/renew_img/img_info03.png">
					<p class="plaintext">メニューバー右上の「ログイン」から、ログインページに遷移してください。</p>
					<img src="/static/renew_img/img_info04.png">
					<p class="plaintext">「Googleアカウントでログイン」することでログインが可能です。<br>
						メールアドレスを入力し、「メールリンクを送る」をクリック。自分のメールアドレスにURLが届くのでクリックすることでログインが可能です。<br>
						データの保存・引き継ぎができるほか、自分のメールアドレスに履歴書を送信することも可能です。</p>
				</li>
				<li>
					<p class="step-num" id="info07"><span>Q</span>ログインができません。</p>
					<p class="plaintext">推奨環境でのご利用をお願いいたします。</p>
					<p class="plaintext">また、iOS端末をお使いの方は、必ずsafariアプリからsafariのブラウザでアクセスしてください。<br>
					Googleにログインできないケース：<br>
					①iOS端末でChromeをお使いの場合、Googleにログインできないことがありますので、『safari』をご利用ください。<br>
					②LINEやGmailなどからYagishのURLをクリックしてアクセスしている場合、ブラウザがSafariでないケースがあります。<br>
					<span class="red">ですので、iOS端末をお使いの方は、必ずsafariアプリからsafariのブラウザでアクセスしてください。</span></p>
					<ul class="disc">
						<li>
							Androidスマートフォン
							<p class="plaintext">OS: 8.0.0以降、<span class="bold">ブラウザ: GoogleChrome</span></p>
						</li>
						<li>
							iPhone
							<p class="plaintext">OS: 11.3以降、<span class="bold">ブラウザ: Safari</span></p>
						</li>
						<li>
							Windows
							<p class="plaintext">OS: Windows10、ブラウザ: GoogleChrome</p>
						</li>
						<li>
							Mac
							<p class="plaintext">OS: High Sierra、ブラウザ: GoogleChrome</p>
						</li>
					</ul>
				</li>
			</ul>	
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2><span>入力データと引き継ぎ</span></h2>
			<ul class="step">
				<li>
					<p class="step-num" id="info08"><span>Q</span>携帯を変えました、データを引き継げますか？</p>
					<p class="plaintext">バックアップを作成いただければ、どの携帯機種からでもログインすることでバックアップデータを引き継ぐことができます。</p>
				</li>
				<li>
					<p class="step-num" id="info09"><span>Q</span>応募先別に入力内容を保存しておくことはできますか？</p>
					<img src="/static/renew_img/img_info02.png">
					<p class="plaintext">保持できる入力内容はテンプレートを問わず共通となっているため、途中で履歴書の種類を変えても内容が引き継がれる代わりに、履歴書ごとに別々の内容を保存することができないようになっています。<br>
					もし応募先ごとに内容を変えたい場合は、「ログイン/マイページ → バックアップを作成」で現時点の内容を手動で保存しておくと、必要なときにその内容を復元することができます。</p>					
				</li>
				<li>
					<p class="step-num" id="info10"><span>Q</span>ログインをしていないのに、以前入力した内容が残っていました。</p>
					<p class="plaintext">ご利用の端末のブラウザ（SafariやChromeなど）に入力内容が保存されているためです。<br>
						この履歴はその端末を使用しているご本人しか見ることはできません。<br>
						<span class="red">データを残したくない場合、「ログイン/マイページ」 → 画面下「設定」 → 「データ・アカウントの削除」からも削除できます。</span>
					</p>
					<div class="delite">
						<a href="https://rirekisho.yagish.jp/account/delete" class="btn_green">データ・アカウントの削除</a>
					</div>

				</li>
				<li>
					<p class="step-num" id="info11"><span>Q</span>入力したデータが消えてしまいました。</p>
					<p class="plaintext">ブラウザの履歴削除や端末の機種変更などでブラウザに保存されたyagish（ヤギッシュ）のデータは消えてしまいます。 <br>
					データが消えてしまわないかご心配な方はサーバーへのバックアップや、PDFをメールで送る機能のご利用をお勧めいたします。<br>
					なお、yagishのヤギが履歴書を食べた事象は現在のところ確認できておりません。<br>
					印刷した履歴書にはインク、トナー等、ヤギの健康に悪い成分が含まれていますので、もしそうしたヤギを発見した場合、健康のためやめさせるようお願いします。
					</p>
				</li>
			</ul>	
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2><span>コンビニ印刷とダウンロード</span></h2>
			<ul class="step">
				<li>
					<p class="step-num" id="info12"><span>Q</span>ダウンロードできません。</p>
					<p class="plaintext">お客様の通信状態によってダウンロードが完了する時間は異なります。ダウンロードボタンを押してからしばらくお待ちください。<br>
					また、一定時間経過するとダウンロードエラーが発生しますので、通信環境の良い環境でお試しください。
					</p>
				</li>
				<li>
					<p class="step-num" id="info13"><span>Q</span>再ダウンロードの方法が分かりません。</p>
					<p class="plaintext">ダウンロードを実行すると、ボタンの色が反転しボタンが押せなくなります。<br>
					以下のいずれかの方法で、ダウンロードボタンを押せるようになります。<br>
						<span class="red">・トップページへ1度戻る</span><br>
						<span class="red">・履歴書を修正する</span><br>
						<span class="red">・ページを再読み込みする(リロード)</span>									
				</p>					
				</li>
				<li>
					<p class="step-num" id="info14"><span>Q</span>カラーと白黒印刷の違いはなんですか？</p>
					<p class="plaintext">カラー印刷は添付した証明写真も印刷されます。<br>
						白黒印刷は添付した証明写真は印刷されません。<br>証明写真を別途貼り付けてください。
					</p>
				</li>
				<li>
					<p class="step-num" id="info15"><span>Q</span>コンビニで印刷できません</p>
					<p class="plaintext"><span class="red">■有効期限をご確認ください。</span><br>
						有効期限は、コンテンツ番号発行から24時間となっています。<br><br>
						有効期限が過ぎた場合やコンテンツ番号を忘れた場合は、再度コンビニ印刷ボタンを押して、コンテンツ番号を再発行してください。<br>
						<span class="red">■ローソン・ファミリーマート以外のコンビニについては、コンテンツ番号発行後、10分程お時間がかかります。</span><br>
						「販売終了もしくは、商品番号の入力が誤っている可能性があります。商品番号をご確認してください。」が表示された場合、少し時間を空けて再度ご入力をお試しください。<br><br>
						<span class="red">■yagishのコンビニ印刷機能は『eプリントサービス』となります。</span><br>
						類似サービスにyagishで発行したコンテンツ番号を入力しても印刷できません。
					</p>
				</li>
				<li>
					<p class="step-num" id="info21"><span>Q</span>学歴・職歴内の線の太さが違います</p>
					<p class="plaintext">Macをお使いの際、Chrome上でダウンロードした履歴書PDFファイルを開くと学歴/職歴などの一部の線が太くなっていることがあります。<br>
						ただ、FinderからPDFファイルを開いていただくと正常な太さになっておりますのでご安心ください。<br>
						また、Yagishからの印刷も正常にできることを確認しております。
					</p>
				</li>
			</ul>	
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2><span>運営会社について</span></h2>
			<ul class="step">
				<li>
					<p class="step-num" id="info16"><span>Q</span>入力した個人情報やデータはどんな風に扱われますか？</p>
					<p class="plaintext">ログインをしない状態でのご利用では、データの入力時/PDF出力のどちらもサーバーにデータは保存されません（お使いの端末のブラウザにのみ残ります）<br>
						ログイン後は、バックアップ等のデータがyagish（ヤギッシュ）のサーバーで保存されます。<br>
						名前や住所など個人を特定される情報がそのまま外部に提供されることはありません。<br>
						Googleのセキュリティを使っているので安心安全です。<br>
						よりよいサービスを提供するため、個人を特定できない形に加工した上で外部サービスと連携したり、新しい機能の開発のため分析を行う際に、データを参照させていただく場合があります。
					</p>
				</li>
				<li>
					<p class="step-num" id="info17"><span>Q</span>運営会社はどんな会社ですか？</p>
					<p class="plaintext">yagish（ヤギッシュ）は株式会社Yagishが運営しているサービスです。</p>					
				</li>
			</ul>	
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2><span>その他</span></h2>
			<ul class="step">
				<li>
					<p class="step-num" id="info18"><span>Q</span>メールが届きません。</p>
					<p class="plaintext">フリーメールやキャリアメールなどのサービスでは、お客様が迷惑メールの設定をしていなくても、プロバイダの設定で自動で迷惑メールへ振り分けられているケースがございます。<br>
					迷惑メールフォルダや迷惑メール設定をご確認ください。
					</p>
				</li>
				<li>
					<p class="step-num" id="info19"><span>Q</span>質問や要望がある場合、どこに問い合わせれば良いですか？</p>
					<p class="plaintext">お問い合わせまたはリクエストについては、 <a href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform" target="_blank">こちらのフォーム</a>よりご連絡ください。</p>					
				</li>
				<li>
					<p class="step-num" id="info20"><span>Q</span>退会したい場合はどうすれば良いですか？</p>
					<p class="plaintext">退会をご希望の場合、「ログイン/マイページ → データ・アカウントの削除」から退会（アカウントの削除）ができます。<br>
					<span class="red">なお、アカウント削除の前に、上記画面から「サーバー上のバックアップの削除」を行う必要がありますのでご確認ください。</span>
					</p>
					<div class="delite">
						<a href="/account/delete" class="btn_green">データ・アカウントの削除</a>
					</div>
				</li>
			</ul>	
		</div>
	</section>
</div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
